module.exports = __webpack_public_path__ + "static/member01-0ab97f2a3151dd8dbee2b66546083510.png";